var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandStack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.5,5c0-0.4,0.3-0.8,0.8-0.8h6C15.7,4.2,16,4.6,16,5v1.2h1.2C17.7,6.2,18,6.6,18,7v1.8h1 c0.4,0,0.8,0.3,0.8,0.8v3c0,0.4-0.3,0.8-0.8,0.8s-0.8-0.3-0.8-0.8v-2.2h-12v7h7.2c0.4,0,0.8,0.3,0.8,0.8S13.9,19,13.4,19h-8 c-0.4,0-0.8-0.3-0.8-0.8V9.5c0-0.4,0.3-0.8,0.8-0.8h1V7c0-0.4,0.3-0.8,0.8-0.8h1.2L8.5,5L8.5,5z M8,8.8h8.5v-1H8V8.8z M14.5,5.8 v0.5H10V5.8H14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.2,15.5c-0.2,0-0.2,0.1-0.1,0.2l2.7,2.7c0.1,0.1,0.4,0.1,0.5,0l2.7-2.7c0.1-0.1,0.1-0.2-0.1-0.2H16.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandStack);
export default __webpack_public_path__ + "static/media/expand-stack.7a2a97b6a4c39b8300ed22237d17b4d5.svg";
export { ForwardRef as ReactComponent };